import React from "react";
import { Toast } from "react-bootstrap";

const ToastContainer = ({ toasts, removeToast }) => {
  return (
    <div style={{ position: "fixed", top: 100, right: 20, zIndex: 9999 }}>
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          onClose={() => removeToast(toast.id)}
          show={true}
          delay={3000}
          autohide
          className={`bg-${toast.type} ${toast.type === 'danger' ? 'text-white' : ''}`}
        >
          <Toast.Header>
            <strong className="me-auto">Notification</strong>
          </Toast.Header>
          <Toast.Body>{toast.message}</Toast.Body>
        </Toast>
      ))}
    </div>
  );
};

export default ToastContainer;
